// Source : chatGPT

// Converts a number to an HSV color value (object with h, s, and v properties)
export function numberToHsv(num) {
    const hue = (num * 137.508) % 360; // Map the number to a hue value (0-360)
    return { h: hue, s: 0.5, v: 0.95 }; // Return an HSV object with fixed saturation and value
}
  
  // Converts an HSV color value to an RGB color value (object with r, g, and b properties)
export function hsvToRgb(hsv) {
    const c = hsv.v * hsv.s; // Chroma
    const hp = hsv.h / 60; // Hue prime
    const x = c * (1 - Math.abs((hp % 2) - 1));
    let rgb1 = [0, 0, 0];
    switch (Math.floor(hp)) {
      case 0:
        rgb1 = [c, x, 0];
        break;
      case 1:
        rgb1 = [x, c, 0];
        break;
      case 2:
        rgb1 = [0, c, x];
        break;
      case 3:
        rgb1 = [0, x, c];
        break;
      case 4:
        rgb1 = [x, 0, c];
        break;
      default:
        rgb1 = [c, 0, x];
        break;
    }
    const m = hsv.v - c;

    return {
      r: Math.round((rgb1[0] + m) * 255),
      g: Math.round((rgb1[1] + m) * 255),
      b: Math.round((rgb1[2] + m) * 255),
    };
}
  
  // Converts an RGB color value to a hexadecimal color string
export function rgbToHex(r, g, b) {
    // Make sure red, green, and blue are within 0-255 range
    r = Math.max(0, Math.min(255, r));
    g = Math.max(0, Math.min(255, g));
    b = Math.max(0, Math.min(255, b));
    // Convert each component to a two-digit hex string and combine them
    return ((r << 16) + (g << 8) + b).toString(16).padStart(6, '0');
}
  
  